export class ColorService {

    private static readonly COLOR_MAP: Partial<Record<DisguiseDto.EnumColor, string>> = {
        BLUE: 'blue',
        GREEN: 'green',
        YELLOW: 'yellow',
        GREY: 'grey',
        RED: 'red',
        PRIMARY: 'primary',
        SECONDARY: 'secondary',
        ORANGE: 'orange',
        AMBER: 'amber',
        SUCCESS: 'success',
        WHITE: 'white',
        BROWN: 'brown',
        LIGHT_GREEN: 'light-green',
        PINK: 'pink',
        PURPLE: 'purple',
        DEEP_PURPLE: 'deep-purple',
        INDIGO: 'indigo',
        LIGHT_BLUE: 'light-blue',
        CYAN: 'cyan',
        TEAL: 'teal',
        LIME: 'lime',
        DEEP_ORANGE: 'deep-orange',
        BLUE_GREY: 'blue-grey'
    };

    private static readonly COLOR_TYPE_MAP: Partial<Record<EnumColorType, string>> = {
        FOREGROUND: '--text',
        BACKGROUND: '',
    };

    getColor(color: DisguiseDto.EnumColor | undefined, colorType: EnumColorType, isDark: boolean, isLightColor: boolean = true) {
        // Dark: AMBER/ORANGE nur für Vordergrund (Buttons/Alerts) auf BROWN; Status-Hintergründe behalten getrennte Töne.
        if (isDark && !isLightColor && (color === 'AMBER' || color === 'ORANGE')) {
            color = 'BROWN';
        }

        let result = color ? (ColorService.COLOR_MAP[color] || '') : '';
        result += ColorService.COLOR_TYPE_MAP[colorType];
        result += this.getTheme(isDark, isLightColor);
        return result;
    }

    private getTheme(isDark: boolean, isLightColor: boolean) {
        if (isLightColor) {
            return isDark ? ' darken-2' : ' lighten-3';
        } else {
            return '';
        }
    }

}

type EnumColorType = 'BACKGROUND' | 'FOREGROUND';

const COLOR_SERVICE_INSTANCE = new ColorService();

export {COLOR_SERVICE_INSTANCE};
